import { useMatch, useSearchParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { SearchParamsKeys } from "@/constants/search";

const QUIZ_THEME_BY_FLOW_ID: Record<string, "flow5gl"> = {
  flow5gl: "flow5gl",
  "flow5gl-discount": "flow5gl",
  photoshoot: "flow5gl",
  "photoshoot-discount": "flow5gl",
};

const getQuizTheme = (flowId?: string) => QUIZ_THEME_BY_FLOW_ID[flowId ?? ""] ?? "quiz";

export const useQuizTheme = () => {
  const [searchParams] = useSearchParams();
  const quizId = useMatch(ROUTES.QUIZ(":quizId"))?.params.quizId;
  const paywallId = useMatch(ROUTES.PAYWALL(":paywallId"))?.params.paywallId;
  const onboardingQuizId = searchParams.get(SearchParamsKeys.QUIZ_ID) ?? undefined;

  return getQuizTheme(quizId ?? paywallId ?? onboardingQuizId);
};
